import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={`modern-header ${isScrolled ? "scrolled" : ""}`}>
      <nav className="header-nav">
        <Link to="/" className="header-brand">
          <div className="brand-icon">C</div>
          <span className="brand-text">Chhatrapal</span>
        </Link>

        <div className="nav-links">
          <Link
            to="/"
            className={
              location.pathname === "/" ? "nav-link active" : "nav-link"
            }
          >
            Home
          </Link>
          {/* <Link to="/portfolio" className={location.pathname === '/portfolio' ? 'nav-link active' : 'nav-link'}>
            Portfolio
          </Link> */}
          <Link
            to="/case-studies"
            className={
              location.pathname === "/case-studies"
                ? "nav-link active"
                : "nav-link"
            }
          >
            Case Studies
          </Link>
          <Link
            to="/contact"
            className={
              location.pathname === "/contact" ? "nav-link active" : "nav-link"
            }
          >
            Contact
          </Link>
          
        </div>

        <Link to="/contact" className="header-cta-btn desktop-only">
          Let's Talk
        </Link>

        <button
          className="mobile-menu-btn"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </nav>

      {isMobileMenuOpen && (
        <div className="mobile-menu">
          <Link to="/" onClick={() => setIsMobileMenuOpen(false)}>
            Home
          </Link>
          
          <Link to="/case-studies" onClick={() => setIsMobileMenuOpen(false)}>
            Case Studies
          </Link>
          <Link to="/contact" onClick={() => setIsMobileMenuOpen(false)}>
            Let's Talk
          </Link>
        </div>
      )}
    </header>
  );
};

export default Header;
